import React from 'react';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import axios from "axios";

class AddEditForm extends React.Component {
  state = {
    email: '',
    id: '',
    privateKey: ''
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  submitFormAdd = e => {
    e.preventDefault();


    try {
      const params = {
        email: this.state.email,
        id: this.state.id,
        privateKey: this.state.privateKey
      };
      axios.post(`https://t2qaedohf6.execute-api.us-east-1.amazonaws.com/stud/studiobo/${this.state.id}`, params)
        // .then(response => response.json())
        .then(res => {
          if (res.status == '201') {
           console.log("res",res.status);
           window.location.reload(); 
          } else {
            console.log('failure')
          }
        })
    }
    catch (err) {
      console.log(err);
    }

  }


  submitFormEdit = e => {
    e.preventDefault()
    try {
      const params = {
        email: this.state.email,
        id: this.state.id,
        privateKey: this.state.privateKey
      };
      axios.patch(`https://t2qaedohf6.execute-api.us-east-1.amazonaws.com/stud/studiobo/${this.state.id}`, params)
        // .then(response => response.json())
        .then(res => {
          if (res.status == '204') {
           console.log("res",res.status);
           window.location.reload(); 
          } else {
            console.log('failure')
          }
        })
    }
    catch (err) {
      console.log(err);
    }
  }

  componentDidMount() {
    // if item exists, populate the state with proper data
    if (this.props.item) {
      const { email, id, privateKey } = this.props.item
      this.setState({ email, id, privateKey })
    }
  }

  render() {
    return (
      <Form onSubmit={this.props.item ? this.submitFormEdit : this.submitFormAdd}>
        <FormGroup>
          <Label for="first">Email</Label>
          <Input type="text" name="email" id="email" onChange={this.onChange} value={this.state.email === null ? '' : this.state.email} />
        </FormGroup>
        <FormGroup>
          <Label for="last">ID</Label>
          <Input type="text" name="id" id="id" onChange={this.onChange} value={this.state.id === null ? '' : this.state.id} />
        </FormGroup>
        <FormGroup>
          <Label for="phone">Private Key</Label>
          <Input type="text" name="privateKey" id="privateKey" onChange={this.onChange} value={this.state.privateKey === null ? '' : this.state.privateKey} placeholder="" />
        </FormGroup>
        <Button>Submit</Button>
      </Form>
    );
  }
}

export default AddEditForm